import { stringUtils } from "cayo.ui";
import globalConstants from "@cayo/shared/components/App/constants";
import { bindingsRegexes } from "@cayo/shared/scheme/bindings/regexes";

const hashUrlBeginPattern = new RegExp("(^#/)|(^/)|^#");

const trim = (url?: string | undefined) => {
  return (url && url.replace(hashUrlBeginPattern, "")) || "";
};

const getSchemeId = (url?: string) => {
  const parts = url?.split("?");
  if (!parts || parts.length < 1) {
    return undefined;
  }

  const schemeId = parts[0].split("/").slice(1);
  return schemeId.join("/");
};

const addRequestTime = (url: string): string => {
  if (!url) {
    return url;
  }

  const separator = url.includes("?") ? "&" : "?";
  const timeParam = `time=${new Date().getTime()}`;
  return `${url}${separator}${timeParam}`;
};

const makeApiPath = (url: string) => {
  let result = globalConstants.apiVersion;
  if (!url.startsWith("/")) {
    result = "/" + result;
  }

  return result + url;
};

const buildRelativePath = (...args: string[]) => {
  const [first, ...other] = args;

  const trimmed = other.map((v) => stringUtils.trim(v, "/"));
  const result = first + (first.endsWith("/") ? "" : "/") + trimmed.join("/");
  return result;
};

const hasBindings = (url: string) => {
  const result = url.match(bindingsRegexes.insideCurlyBrackets);
  return !!result;
};

const getRouteFromApiPath = (s: string) => {
  const groups = s.match(/^v0\/([^?]*)/);
  return groups && groups[1];
};

const isLastSegmentTypeCast = (s: string) => {
  const match = s.match(/([^/]+$)/);

  return match && match.length === 1 && match[0].indexOf(".") > 0;
};

const replaceLastSegment = (s: string, newSegment: string) => {
  return s.replace(/([^/]+$)/, newSegment);
};

function getRoute(url: string) {
  const index = url.indexOf("?");
  if (index > 0) {
    return url.substring(0, index);
  }

  return url;
}

const makeRelativePath = (path: string) => {
  if (!path.startsWith("/")) {
    return "/" + path;
  }
  return path;
};

// TODO: fix for absolute urls
const addPublicUrl = (url: string) => {
  const baseUrl = import.meta.env.BASE_URL || "/";

  return baseUrl.endsWith("/") ? baseUrl + url : baseUrl + "/" + url;
};

function removeTrailingGuid(path: string) {
  const guidRegex = /^[0-9a-fA-F]{32}$/;
  const parts = path.split("/");
  const LAST_INDEX_EXCLUSIVE = -1;

  if (
    guidRegex.test(parts[parts.length - 1]) &&
    parts.slice(0, LAST_INDEX_EXCLUSIVE).every((part) => !guidRegex.test(part))
  ) {
    parts.pop();
  }

  return parts.join("/");
}

export const urlUtils = {
  trim,
  getSchemeId,
  addRequestTime,
  makeApiPath,
  hasBindings,
  buildRelativePath,
  getRouteFromApiPath,
  replaceLastSegment,
  getRoute,
  makeRelativePath,
  addPublicUrl,
  isLastSegmentTypeCast,
  removeTrailingGuid,
};
